<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>轮播图管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">




      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="selectSlideshow()">查询</el-button>
      </el-form-item>

      <el-form-item label="">

        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column prop="name" label="主图" width="120"> 

        <template slot-scope="scope">
          <img  style="width: 90px;height: 90px;" :src="scope.row.img_url">
        </template>

      </el-table-column>
      <el-table-column sortable prop="web_site" label="跳转地址" width="200">
      </el-table-column>





      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">

          <el-button size="mini" v-if="scope.row.isShow==0" @click="upIsShowCarousel(1, scope.row)">上架</el-button>
          <el-button size="mini"  v-if="scope.row.isShow==1" @click="upIsShowCarousel(0, scope.row)">下架</el-button>    

          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteSlideshow(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px"   ref="editForm">
        <el-form-item label="跳转地址" prop="deptName">
          <el-input size="small" v-model="formData.web_site" auto-complete="off" placeholder="不填写不跳转"></el-input>
        </el-form-item>

        <el-form-item label="主图" style="">

            <div class="upload-demo">
                  <el-upload
                  action=""
                  :http-request="mainImgUpload"
                  :show-file-list="false"
                  list-type="picture-card" >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <img v-if="formData.img_url" :src="formData.img_url" class="avatar">
     
            </div>
                
        </el-form-item>  


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="addSlideshow()" v-if="title=='添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="upSlideshow()" v-if="title=='修改'">修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {

  addDishes,


  
  addSlideshow,
  upSlideshow,
  deleteSlideshow,
  selectSlideshow,
  


} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import client from "@/utils/ossClient.js";
export default {
  data() {
    return {
      type:0,
      typeArr: [
        { key: '首页', value: 0 },
        { key: '交易区', value: 1 }
      ],

      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",

      listData: [], //
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10,
      },


      formData: {
        img_url:"",
        web_site:""
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.selectSlideshow()

  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
        // 删除
        deleteSlideshow(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteSlideshow({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "已删除！",
                });
                this.selectSlideshow();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

        //修改轮播图
        upSlideshow() {

      this.loading = true;
      var formData = JSON.parse(JSON.stringify(this.formData));


      upSlideshow(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisible=false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.selectSlideshow();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //添加轮播图
    addSlideshow() {

      this.loading = true;
      this.formData.type = this.type;

      var formData = JSON.parse(JSON.stringify(this.formData))


      

      addSlideshow(this.formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisible=false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.selectSlideshow();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //自定义上传方法..
    mainImgUpload(file) {

      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      if (names.indexOf(exname) < 0) {
        this.$message.error("不支持的格式!");
        return;
      }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            this.formData.img_url = res.url;
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => {});
    },


    // 获取轮播图
    selectSlideshow() {
      this.loading = true;

      selectSlideshow({type:this.type}).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.data;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },

    // 分页插件事件
    callFather(parm) {
      this.getDishesList(parm.currentPage);
    },

    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.formData.id = row.id;
        this.formData.img_url = row.img_url;
        this.formData.web_site = row.web_site;
        this.formData.isShow = row.isShow;

      } else {
        this.title = "添加";
        this.formData.id = "";
        this.formData.img_url = "";
        this.formData.web_site = "";
      }
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.upload-demo {
  display: flex;
  flex-direction: row;
}

.upload-demo img {
  width: 140px;
  height: 140px;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/terrace/Carousel.vue